import React from 'react';
import ManageAgreementsForm from './Components/ManageAgreementsForm';

const ManageAgreementsPage = () => {
  return (
    <div className="w-full h-full">
      <div className="pb-1">
        <ManageAgreementsForm />
      </div>
    </div>
  );
};

export default ManageAgreementsPage;
